export default "__VITE_ASSET__12e1d5c0__"